module.exports = __webpack_public_path__ + "img/mejdahl.22a443a1.png";